import { MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { isLeftMouseButtonEvent } from '../../utils/inputEventUtils';
import { openWindowInNewTab, shouldOpenInNewTab } from '../../utils/navigationUtils';

interface NavigationOptions {
  route: string;
  routeForNewTab?: string;
}

interface useCustomNavigateResult {
  navigateOnMouseUp: (event: MouseEvent, opt: NavigationOptions) => void;
}

const useCustomNavigate = (): useCustomNavigateResult => {
  const navigate = useNavigate();

  const navigateOnMouseUp = (event: MouseEvent, { route, routeForNewTab }: NavigationOptions) => {
    const isOpenInNewTab = shouldOpenInNewTab(event);
    if (isOpenInNewTab) {
      openWindowInNewTab(routeForNewTab ?? route);
    } else if (isLeftMouseButtonEvent(event)) {
      navigate(route);
    }
  };

  return { navigateOnMouseUp };
};

export default useCustomNavigate;
